export default __webpack_public_path__ + "static/media/target.e5ce4fb5.jpg";